import script from "./ExamesCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamesCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./ExamesCriarEditar.vue?vue&type=style&index=0&id=b7ad58ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7ad58ac"]])

export default __exports__